import React from 'react';
import PageContainer from "../container/page";
import PopupSearch from "../components/popup/PopupSearch";
import PopupMobileMenu from "../components/popup/PopupMobileMenu";

const LayoutDefault = ({children, className, revealFooter, revealSection}) => {
    return (
        <PageContainer className={className} revealFooter={revealFooter} revealSection={revealSection}>
            <PopupSearch/>
            <PopupMobileMenu/>
            {children}
        </PageContainer>
    );
};

export default LayoutDefault;